export default function appendUrlParam(url, properties) {
  const params = Object.keys(properties).map(p => `${encodeURIComponent(p)}=${encodeURIComponent(properties[p])}`).join('&');
  const alreadyHasParams = url.indexOf('?') > -1;
  // append new params, don't care about if url has hash part, vue wants the params behind the hash part anyway
  return url + (alreadyHasParams ? '&' : '?') + params;
}
